export default __webpack_public_path__ + "static/media/No50Open.25ecaa96.jpg";